/**
 * Stable CSS class names for E2E — Product comments / Comment reject reason management.
 */
export const CRR = {
    page: 'product-comments-comment-reject-reason-page',
    breadcrumbSection: 'product-comments-comment-reject-reason-page__breadcrumb-section',

    drawerPaper: 'product-comments-comment-reject-reason-page__drawer-paper',
    drawerContent: 'product-comments-comment-reject-reason-page__drawer-content',

    actionsRow: 'product-comments-comment-reject-reason-page__actions-row',
    addButton: 'product-comments-comment-reject-reason-page-input--button-add',

    gridSection: 'product-comments-comment-reject-reason-page__grid-section',
} as const;

export const CRR_D = {
    card: 'comment-reject-reason-drawer__card',
    content: 'comment-reject-reason-drawer__content',
    layout: 'comment-reject-reason-drawer__layout',

    headerRow: 'comment-reject-reason-drawer__header-row',
    title: 'comment-reject-reason-drawer__title',
    closeIcon: 'comment-reject-reason-drawer-input--button-close',

    formGrid: 'comment-reject-reason-drawer__form-grid',
    textFieldReason: 'comment-reject-reason-drawer-input--text-reason',

    footerRow: 'comment-reject-reason-drawer__footer-row',
    saveButton: 'comment-reject-reason-drawer-input--button-save',
} as const;

export const CRR_G = {
    gridWrap: 'comment-reject-reason-grid__wrap',
    dataGridWrap: 'comment-reject-reason-grid__data-grid-wrap',

    rowMenuButton: 'comment-reject-reason-grid-input--button-row-menu',
    rowMenuPaper: 'comment-reject-reason-grid__row-menu-paper',
    rowMenuItemEdit: 'comment-reject-reason-grid-input--menu-item-edit',
    rowMenuItemDelete: 'comment-reject-reason-grid-input--menu-item-delete',
} as const;

export const crrCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

